import { render } from "./TheSignup.vue?vue&type=template&id=b5da5530&scoped=true"
import script from "./TheSignup.vue?vue&type=script&lang=js"
export * from "./TheSignup.vue?vue&type=script&lang=js"

import "./TheSignup.vue?vue&type=style&index=0&id=b5da5530&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5da5530"]])

export default __exports__